import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import React from "react";
import { StyledBaseButton } from "./BaseButton.styles";

const BaseButton = React.forwardRef(
    (
        {
            to,
            href,
            target = "_blank",
            rel = "noopener noreferrer",
            isInternalUrlNewTab = false,
            tooltip,
            ...rest
        },
        ref
    ) => {
        const linkTarget = to || href;
        const isLink = linkTarget !== undefined;
        const isExternalUrl =
            (typeof linkTarget === "string" &&
                /^https?:\/\//.test(linkTarget)) ||
            isInternalUrlNewTab;

        const elementForLink = isLink ? Link : "button";
        const Element = isExternalUrl ? "a" : elementForLink;
        const propsForLink = isLink ? { to: linkTarget } : {};
        const props = isExternalUrl ? { href: linkTarget, target, rel } : propsForLink;

        return <StyledBaseButton as={Element} ref={ref} {...props} {...rest} title={tooltip} />;
    }
);

BaseButton.propTypes = {
    to: PropTypes.string,
    href: PropTypes.string,
    target: PropTypes.string,
    rel: PropTypes.string,
    isInternalUrlNewTab: PropTypes.bool,
    tooltip: PropTypes.string,
};

export default BaseButton;
